"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AProtocolWriter = exports.AProtocolReader = exports.AProtocol = void 0;
const headers_1 = require("./headers");
class AProtocol {
}
exports.AProtocol = AProtocol;
class AProtocolReader {
    readRequestHeader() {
        const actionName = this.readStringValue();
        const argumentCount = this.readIntegerValue();
        return new headers_1.RequestHeader(actionName, argumentCount);
    }
    readRequestArgumentHeader() {
        const argumentName = this.readStringValue();
        const type = this.readStringValue();
        return new headers_1.RequestArgumentHeader(argumentName, type);
    }
    readResponseHeader() {
        const success = this.readBooleanValue();
        const type = this.readStringValue();
        const argumentCount = this.readIntegerValue();
        return new headers_1.ResponseHeader(success, type, argumentCount);
    }
    readResponseArgumentHeader() {
        const argumentName = this.readStringValue();
        const type = this.readStringValue();
        return new headers_1.ResponseArgumentHeader(argumentName, type);
    }
    readModelHeader() {
        const modelName = this.readStringValue();
        const propertyCount = this.readIntegerValue();
        return new headers_1.ModelHeader(modelName, propertyCount);
    }
    readModelPropertyHeader() {
        const propertyName = this.readStringValue();
        const type = this.readStringValue();
        return new headers_1.ModelPropertyHeader(propertyName, type);
    }
    readArrayHeader() {
        const itemCount = this.readIntegerValue();
        return new headers_1.ArrayHeader(itemCount);
    }
    readArrayItemHeader() {
        const type = this.readStringValue();
        return new headers_1.ArrayItemHeader(type);
    }
    readDictionaryHeader() {
        const recordCount = this.readIntegerValue();
        return new headers_1.DictionaryHeader(recordCount);
    }
    readDictionaryItemHeader() {
        const keyType = this.readStringValue();
        const valueType = this.readStringValue();
        return new headers_1.DictionaryItemHeader(keyType, valueType);
    }
    readIndefiniteValueHeader() {
        const valueType = this.readStringValue();
        return new headers_1.IndefiniteValueHeader(valueType);
    }
}
exports.AProtocolReader = AProtocolReader;
class AProtocolWriter {
    writeRequestHeader(header) {
        this.writeStringValue(header.actionName);
        this.writeIntegerValue(header.argumentCount);
    }
    writeRequestArgumentHeader(header) {
        this.writeStringValue(header.argumentName);
        this.writeStringValue(header.type);
    }
    writeResponseHeader(header) {
        this.writeBooleanValue(header.success);
        this.writeStringValue(header.type);
        this.writeIntegerValue(header.argumentCount);
    }
    writeResponseArgumentHeader(header) {
        this.writeStringValue(header.argumentName);
        this.writeStringValue(header.type);
    }
    writeModelHeader(header) {
        this.writeStringValue(header.modelName);
        this.writeIntegerValue(header.propertyCount);
    }
    writeModelPropertyHeader(header) {
        this.writeStringValue(header.propertyName);
        this.writeStringValue(header.type);
    }
    writeArrayHeader(header) {
        this.writeIntegerValue(header.itemCount);
    }
    writeArrayItemHeader(header) {
        this.writeStringValue(header.type);
    }
    writeDictionaryHeader(header) {
        this.writeIntegerValue(header.recordCount);
    }
    writeDictionaryItemHeader(header) {
        this.writeStringValue(header.keyType);
        this.writeStringValue(header.valueType);
    }
    writeIndefiniteValueHeader(header) {
        this.writeStringValue(header.valueType);
    }
}
exports.AProtocolWriter = AProtocolWriter;
